import { createActions, createReducer } from "reduxsauce";
import { onChangeFieldValue, vehicleStepsSelected } from "utils/functions";
import { defaultState } from "./location-model";

export const { Types, Creators } = createActions({
  locationsShowLoading: [],
  locationsHideLoading: [],
  locationsShowLoadingTable: [],
  locationsHideLoadingTable: [],
  locationsShowLoadingLocationEdit: [],
  locationsHideLoadingLocationEdit: [],
  locationsList: ["locationList"],
  locationsActiveList: ["locationActiveList"],
  locationsProcessList: ["processList"],
  locationsStructuresList: ["structuresList"],
  locationsStructuresAllList: ["structuresAllList"],
  locationsByStructureIdList: ["locationByStructureIdList"],
  locationsStructureByLocation: ["locationStructure"],
  locationsUpdateFormModified: ["formViewOrEditModified"],
  locationsCreateActive: ["createActive"],
  locationsFetchRegister: ["items", "totalItems"],
  locationsChangeFieldValue: ["fieldName", "value"],
  locationsUpdateItemActive: ["itemActive"],
  locationsUpdateProcessActive: ["processActive"],
  locationsUpdateFilter: ["filter"],
  locationsStructureActive: ["structureActive"],
  locationsHasAttendanceActive: ["hasAttendanceActive"],
  locationsHasEntryPermissionActive: ["hasEntryPermissionActive"],
  locationsExpirationTimeActive: ["expirationTimeActive"],
  locationsCheckinActive: ["checkinActive"],
  locationsAllowRequestVehicleInboundActionActive: ["requestVehicleInboundActionActive"],
  locationsAllowRequestDockEntryActionActive: ["requestDockEntryActionActive"],
  locationsHasFinishOperationActionActive: ["hasFinishOperationAction"],
  locationsReleaseVehicleActionActive: ["releaseVehicleActionActive"],
  locationsAllowVehicleArrivalConfirmActionActive: ["vehicleArrivalConfirmActionActive"],
  locationsAllowCreateManeuverAsCheckinActive: ["createManeuverAsCheckinActive"],
  locationsHasReleaseWMSDocumentsActionActive: ["hasReleaseWMSDocumentsActive"],
  locationsHasLocationOutOfRangeActive: ["hasLocationOutOfRangeActive"],
  locationsDocumentNumberActive: ["documentTypeActive"],
  locationsDropHookActive: ["dropHookTypeOfYard"],
  locationsHasCheckinScheduleActive: ["hasCheckinScheduleActive"],
  locationsHasRfidReadingActive: ["hasRfidReadingActive"],
  locationsPlateFormatActive: ["plateFormatType"],
  locationsConfigurationsUpdateFormFieldValue: ["fieldName", "fieldValue"],
  locationsConfigurationsProcessUpdateFormFieldValue: ["processActive"],
  locationsConfigurationsShowDrawer: [],
  locationsConfigurationsHideDrawer: [],
  locationsConfigurationsProcessShowDrawer: [],
  locationsConfigurationsProcessHideDrawer: [],
  locationsCleanConfigurations: [],
  locationStructureByLocationFetchAsync: ["location"],
  locationsFetchByIdAsync: ["id"],
  locationProcessesFetchAsync: [""],
  locationStructuresFetchAsync: [""],
  locationStructuresAllFetchAsync: [""],
  locationByStructureIdFetchAsync: ["id"],
  locationsFetchRegisterAsync: [],
  locationSaveAsync: ["body", "id"],
  locationFetchAsync: [],
  locationActiveFetchPublicAsync: [],
  locationActiveFetchAsync: [],
  locationsConfigurationsUpdateConfigurationActive: ["configurationActive"],
  locationsConfigurationsUpdateConfigurationProcessActive: ["configurationProcessActive"],
  locationsConfigurationsUpdateConfigurationProcessList: ["configurationProcess"],
});
export const cleanConfigurations = (state = defaultState) => ({
  ...state,
  hasAttendanceActive: false,
  checkinActive: false,
  expirationTimeActive: 48,
  requestVehicleInboundActionActive: false,
  requestDockEntryActionActive: false,
  hasFinishOperationActionActive: false,
  releaseVehicleActionActive: false,
  vehicleArrivalConfirmActionActive: false,
  hasReleaseWMSDocumentsActive: false,
  hasLocationOutOfRangeActive: false,
  hasCheckinScheduleActive: false,
  documentTypeActive: 0,
  dropHookTypeActive: null,
  dropHookActive: false,
  hasEntryPermissionActive: false,
  hasRfidReadingActive: false,
  plateFormatType: 0,
});

export const showLoadingLocationEdit = (state = defaultState) => ({
  ...state,
  isLoadingLocationEdit: true,
});

export const hideLoadingLocationEdit = (state = defaultState) => ({
  ...state,
  isLoadingLocationEdit: false,
});

export const showDrawer = (state = defaultState) => ({
  ...state,
  visibleDrawer: true,
});

export const hideDrawer = (state = defaultState) => ({
  ...state,
  visibleDrawer: false,
  configurationActive: defaultState.configurationActive,
});

export const showProcessDrawer = (state = defaultState) => ({
  ...state,
  visibleProcessDrawer: true,
});

export const hideProcessDrawer = (state = defaultState) => ({
  ...state,
  visibleProcessDrawer: false,
  configurationProcessActive: defaultState.configurationProcessActive,
});

export const hideLoadingTable = (state = defaultState) => ({
  ...state,
  isLoadingTable: false,
});

export const showLoadingTable = (state = defaultState) => ({
  ...state,
  isLoadingTable: true,
});

export const setLocationList = (state, { locationList }) => ({
  ...state,
  ...locationList,
});

export const setLocationActiveList = (state, { locationActiveList }) => ({
  ...state,
  ...locationActiveList,
});

export const setProcessesList = (state, { processList }) => {
  return {
    ...state,
    processList,
    originalProcessList: [...processList],
  };
};

export const setStructuresList = (state, { structuresList }) => ({
  ...state,
  ...structuresList,
});

export const setStructuresAllList = (state, { structuresAllList }) => ({
  ...state,
  ...structuresAllList,
});

export const setLocationByStrucutureIdList = (state, action: any) => ({
  ...state,
  locationByStructureIdList: action.locationByStructureIdList,
});

export const setStrucutureByLocation = (state, action: any) => ({
  ...state,
  locationStructure: action.locationStructure,
});

export const showLoading = (state = defaultState) => ({
  ...state,
  isLoading: true,
});

export const hideLoading = (state = defaultState) => ({
  ...state,
  isLoading: false,
});

export const updateformViewOrEditModified = (state, action: any) => ({
  ...state,
  formViewOrEditModified: action.formViewOrEditModified,
});

export const createActive = (state, action: any) => ({
  ...state,
  createActive: action.createActive,
});

export const fetchLocation = (state, { items, totalItems }) => ({
  ...state,
  isLoading: false,
  items,
  totalItems,
});

export const changeFieldValue = (state, { fieldName, value }) => ({
  ...state,
  filter: onChangeFieldValue(state.filter, fieldName, value),
});

export const updateItemActive = (state, action: any) => ({
  ...state,
  itemActive: action.itemActive,
});

export const updateProcessActive = (state, action: any) => {
  let copyProcessList = state.processList;
  const processesId = action.processActive.map((x) => x.id);
  const processActive = action.processActive.map((x) => x);

  copyProcessList = copyProcessList.map((x) => ({
    ...x,
    active: processesId.includes(x.id),
    vehicleSteps: vehicleStepsSelected([x.id], processActive).flat(),
  }));
  return {
    ...state,
    processActive: action.processActive,
    processList: copyProcessList,
  };
};

export const updateStructureActive = (state, action: any) => ({
  ...state,
  structureActive: action.structureActive,
});

export const updateHasAttendanceActive = (state, action: any) => ({
  ...state,
  hasAttendanceActive: action.hasAttendanceActive,
});

export const updatePlateFormatActive = (state, action: any) => ({
  ...state,
  plateFormatType: action.plateFormatType,
});

export const updateExpirationTimeActive = (state, action: any) => ({
  ...state,
  expirationTimeActive: action.expirationTimeActive,
});

export const updateCheckinActive = (state, action: any) => ({
  ...state,
  checkinActive: action.checkinActive,
});

export const updateFilter = (state, action: any) => {
  return {
    ...state,
    searchFilter: action.filter,
  };
};

export const updateRequestVehicleInboundActionActive = (state, action: any) => ({
  ...state,
  requestVehicleInboundActionActive: action.requestVehicleInboundActionActive,
});

export const updateRequestDockEntryActionActive = (state, action: any) => ({
  ...state,
  requestDockEntryActionActive: action.requestDockEntryActionActive,
});

export const updateHasFinishOperationAction = (state, action: any) => ({
  ...state,
  hasFinishOperationActionActive: action.hasFinishOperationAction,
});

export const updateReleaseVehicleAction = (state, action: any) => ({
  ...state,
  releaseVehicleActionActive: action.releaseVehicleActionActive,
});

export const updateVehicleArrivalConfirmActionActive = (state, action: any) => ({
  ...state,
  vehicleArrivalConfirmActionActive: action.vehicleArrivalConfirmActionActive,
});

export const updateCreateManeuverAsCheckinActive = (state, action: any) => ({
  ...state,
  createManeuverAsCheckinActive: action.createManeuverAsCheckinActive,
});

export const updateHasCheckinScheduleActive = (state, action: any) => ({
  ...state,
  hasCheckinScheduleActive: action.hasCheckinScheduleActive,
});

export const updateHasReleaseWMSDocumentsActionActive = (state, action: any) => ({
  ...state,
  hasReleaseWMSDocumentsActive: action.hasReleaseWMSDocumentsActive,
});

export const updateHasLocationOutOfRangeActive = (state, action: any) => ({
  ...state,
  hasLocationOutOfRangeActive: action.hasLocationOutOfRangeActive,
});

export const updateHasRfidReadingActive = (state, action: any) => ({
  ...state,
  hasRfidReadingActive: action.hasRfidReadingActive,
});

export const updateFormFieldValue = (state, { fieldName, fieldValue }) => ({
  ...state,
  [fieldName]: fieldValue,
});

export const updateProcessFormFieldValue = (state, { processActive }) => {
  const updatedProcessList = state.processList.map((process) => (process.id === processActive.id ? { ...process, ...processActive } : process));

  return {
    ...state,
    processList: updatedProcessList,
  };
};

export const updateFormConfigurationActive = (state, { configurationActive }) => {
  if (configurationActive) {
    return {
      ...state,
      configurationActive: {
        ...configurationActive,
      },
    };
  }
  return state;
};

export const updateFormConfigurationProcessActive = (state, { configurationProcessActive }) => {
  if (configurationProcessActive) {
    return {
      ...state,
      configurationProcessActive: {
        ...state.configurationProcessActive,
        ...configurationProcessActive,
      },
    };
  }
  return state;
};

export const updateFormConfigurationProcessList = (state, { configurationProcess }) => {
  if (configurationProcess) {
    return {
      ...state,
      processList: {
        ...state.processList,
        ...configurationProcess,
      },
    };
  }
  return state;
};

export const updateDocumentNumberActive = (state, action: any) => ({
  ...state,
  documentTypeActive: action.documentTypeActive,
});

export const updateHasEntryPermissionActive = (state, action: any) => ({
  ...state,
  hasEntryPermissionActive: action.hasEntryPermissionActive,
});

export const updateDropHookTypeActive = (state, action: any) => ({
  ...state,
  dropHookTypeActive: action.dropHookTypeOfYard,
  dropHookActive: !!action.dropHookTypeOfYard,
});

export default createReducer(defaultState, {
  [Types.LOCATIONS_LIST]: setLocationList,
  [Types.LOCATIONS_ACTIVE_LIST]: setLocationActiveList,
  [Types.LOCATIONS_SHOW_LOADING]: showLoading,
  [Types.LOCATIONS_HIDE_LOADING]: hideLoading,
  [Types.LOCATIONS_SHOW_LOADING_TABLE]: showLoadingTable,
  [Types.LOCATIONS_HIDE_LOADING_TABLE]: hideLoadingTable,
  [Types.LOCATIONS_SHOW_LOADING_LOCATION_EDIT]: showLoadingLocationEdit,
  [Types.LOCATIONS_HIDE_LOADING_LOCATION_EDIT]: hideLoadingLocationEdit,
  [Types.LOCATIONS_UPDATE_FORM_MODIFIED]: updateformViewOrEditModified,
  [Types.LOCATIONS_CREATE_ACTIVE]: createActive,
  [Types.LOCATIONS_PROCESS_LIST]: setProcessesList,
  [Types.LOCATIONS_FETCH_REGISTER]: fetchLocation,
  [Types.LOCATIONS_CHANGE_FIELD_VALUE]: changeFieldValue,
  [Types.LOCATIONS_UPDATE_ITEM_ACTIVE]: updateItemActive,
  [Types.LOCATIONS_UPDATE_PROCESS_ACTIVE]: updateProcessActive,
  [Types.LOCATIONS_UPDATE_FILTER]: updateFilter,
  [Types.LOCATIONS_STRUCTURES_LIST]: setStructuresList,
  [Types.LOCATIONS_STRUCTURES_ALL_LIST]: setStructuresAllList,
  [Types.LOCATIONS_BY_STRUCTURE_ID_LIST]: setLocationByStrucutureIdList,
  [Types.LOCATIONS_STRUCTURE_BY_LOCATION]: setStrucutureByLocation,
  [Types.LOCATIONS_STRUCTURE_ACTIVE]: updateStructureActive,
  [Types.LOCATIONS_HAS_ATTENDANCE_ACTIVE]: updateHasAttendanceActive,
  [Types.LOCATIONS_EXPIRATION_TIME_ACTIVE]: updateExpirationTimeActive,
  [Types.LOCATIONS_CHECKIN_ACTIVE]: updateCheckinActive,
  [Types.LOCATIONS_ALLOW_REQUEST_VEHICLE_INBOUND_ACTION_ACTIVE]: updateRequestVehicleInboundActionActive,
  [Types.LOCATIONS_ALLOW_REQUEST_DOCK_ENTRY_ACTION_ACTIVE]: updateRequestDockEntryActionActive,
  [Types.LOCATIONS_ALLOW_VEHICLE_ARRIVAL_CONFIRM_ACTION_ACTIVE]: updateVehicleArrivalConfirmActionActive,
  [Types.LOCATIONS_HAS_FINISH_OPERATION_ACTION_ACTIVE]: updateHasFinishOperationAction,
  [Types.LOCATIONS_DOCUMENT_NUMBER_ACTIVE]: updateDocumentNumberActive,
  [Types.LOCATIONS_RELEASE_VEHICLE_ACTION_ACTIVE]: updateReleaseVehicleAction,
  [Types.LOCATIONS_HAS_RELEASE_WMS_DOCUMENTS_ACTION_ACTIVE]: updateHasReleaseWMSDocumentsActionActive,
  [Types.LOCATIONS_HAS_LOCATION_OUT_OF_RANGE_ACTIVE]: updateHasLocationOutOfRangeActive,
  [Types.LOCATIONS_HAS_CHECKIN_SCHEDULE_ACTIVE]: updateHasCheckinScheduleActive,
  [Types.LOCATIONS_HAS_ENTRY_PERMISSION_ACTIVE]: updateHasEntryPermissionActive,
  [Types.LOCATIONS_CLEAN_CONFIGURATIONS]: cleanConfigurations,
  [Types.LOCATIONS_CONFIGURATIONS_UPDATE_FORM_FIELD_VALUE]: updateFormFieldValue,
  [Types.LOCATIONS_CONFIGURATIONS_PROCESS_UPDATE_FORM_FIELD_VALUE]: updateProcessFormFieldValue,
  [Types.LOCATIONS_CONFIGURATIONS_SHOW_DRAWER]: showDrawer,
  [Types.LOCATIONS_CONFIGURATIONS_HIDE_DRAWER]: hideDrawer,
  [Types.LOCATIONS_CONFIGURATIONS_PROCESS_SHOW_DRAWER]: showProcessDrawer,
  [Types.LOCATIONS_CONFIGURATIONS_PROCESS_HIDE_DRAWER]: hideProcessDrawer,
  [Types.LOCATIONS_CONFIGURATIONS_UPDATE_CONFIGURATION_ACTIVE]: updateFormConfigurationActive,
  [Types.LOCATIONS_DROP_HOOK_ACTIVE]: updateDropHookTypeActive,
  [Types.LOCATIONS_CONFIGURATIONS_UPDATE_CONFIGURATION_PROCESS_ACTIVE]: updateFormConfigurationProcessActive,
  [Types.LOCATIONS_CONFIGURATIONS_UPDATE_CONFIGURATION_PROCESS_LIST]: updateFormConfigurationProcessList,
  [Types.LOCATIONS_HAS_RFID_READING_ACTIVE]: updateHasRfidReadingActive,
  [Types.LOCATIONS_PLATE_FORMAT_ACTIVE]: updatePlateFormatActive,
});
